import api from '@/api'
import axios from 'axios'

//获取地址列表
export async function getAddressList() {
  return api.get('api/services/app/FrontendReceiveAddress/GetReceiveAddress')
}

//修改或编辑
export async function createOrEdit(data) {
  return  api.post('api/services/app/FrontendReceiveAddress/CreateOrUpdate', data)
}

//删除
export async function Delete(data) {
  return  api.delete('api/services/app/FrontendReceiveAddress/Delete?id='+data.id)
}



// WEBPACK FOOTER //
// ./src/api/deliveryAddress.js